'use strict'

export const BASE_PATH = '/mgr'

export const LOGIN = BASE_PATH + '/diseasedStrain/v2/login' // 登陆接口

export const URL_POST_EVENT_TRACKING = '/information/user-behavior/user-operation/batch' // 上传事件埋点数据

export const URL_SERVICE_PLOT_COUNT = BASE_PATH + '/service-plot-count' // 获取各服务类型地块统计
export const URL_SERVICE_COLLECT_PLOT_COUNT = BASE_PATH + '/service-collect-plot-count' // 获取服务履约统计
export const URL_PLOT_SERVICE_TABLE = BASE_PATH + '/statistic/plot-service' // 获取服务履约统计

export const URL_AVERAGE_PER_DAY = BASE_PATH + '/efficiency-collect-daily-average' // 获取人效的柱状图数据
export const URL_LATE_SERVICE = BASE_PATH + '/efficiency-overtime-plotnum' // 获取人效的饼图数据
export const URL_WORKERS_LOAD = BASE_PATH + '/workers-load' // 获取人效的饼图数据
export const URL_EVER_COLLECTED_INDICATOR_LAST_VALUE = '/plot_summary/ever-collected-indicator-last-value' // 指定地块在指定时间段内，所有采集过的指标项的最近一次指标值。
export const URL_INDICATOR_HISTORY_VALUE_AND_EVALUATION = 'plot_summary/getOneIndicatorHistoryList' // 获取趋势图
export const UEL_PLOT_SUMMARY_WITH_GROW_STAGE = '/plot_summary/plot-summary-with-growth-stage' // 地块摘要信息及进入各生育期的日期
export const URL_BASE_MANAGEMENT_LIST = '/plot_summary/base' // 查询基地列表
export const URL_PLOT_LIST = '/plot_summary/plot' // 查询地块列表
export const URL_PLOT_WITH_BOUNDARY = '/plot/circlePlot' // 获取圈地块列表
export const URL_PLOT_BOUNDARY = '/plot/boundary' // 修改圈地
export const URL_PLOT_COLLECTION_AND_VALUE_BY_TYPE = 'indicator-collection/v1/plot-collection-value' // 查询指定地块、指定采集类型的采集记录及其指标值
export const URL_FROST_TEMPERATURE = '/frost-and-temperature/frost-temperature'

export const USER_WITH_AUTHORIZED_PLOTMGMT = BASE_PATH + '/plotMgmt/user-authorized-org' // 获取所有公司人员信息

export const URL_ALL_PLOTMGMT = BASE_PATH + '/plotMgmt/allPlotMgmt' // 获取用户授权页面 所有组织列表

export const URL_EQUIPMENT_SUPPLIER = BASE_PATH + '/device/v1/supplier' // 获取设备供应商列表

export const URL_EQUIPMENT_WORK_STATE_OPTION = BASE_PATH + '/device/v1/work-state-option' // 获取可选的设备工作状态列表

export const URL_EQUIPMENT_WITH_WORK_STATE = BASE_PATH + '/device/v1/device-with-state' // 获取所有设备信息

export const URL_SIMCARD_SUPPLIER = BASE_PATH + '/device/v1/supplier' // 获取所有sim卡供应商

export const URL_SIMCARD_STATE_OPTION = BASE_PATH + '/device/v1/sim-state-option' // 获取可选的sim卡状态列表

export const URL_SIMCARD = BASE_PATH + '/device/v1/simcard' // 获取所有sim卡信息

export const URL_EQUIPMENT_FIRMWARE_UPGRADE_TASK = BASE_PATH + '/device/v1/firmware-upgrade-task' // 设备固件升级任务

export const URL_EQUIPMENT_MODEL = BASE_PATH + '/device/v1/model' // 设备类型

export const URL_EQUIPMENT_FIRMWARE_EDITION = BASE_PATH + '/device/v1/firmware-edition' // 设备版本

export const URL_STAFF_INFO = BASE_PATH + '/plotMgmt/authorized-org' // 根据用户id获取用户权限信息

export const URL_ORGANIZATION_AUTHORIZE = BASE_PATH + '/plotMgmt/authorize' // 给用户授权基地的服务权限

export const URL_ACCOUNT = BASE_PATH + '/account' // 账号相关的接口，查询账号、添加账号、变更账号

export const URL_TOKEN = BASE_PATH + '/token' // 用户口令查询

export const URL_EXPORT_PLOT_WITH_BOUND_DEVICE = BASE_PATH + '/plotMgmt/export-plot-with-sm' // 导出地块及绑定的土壤仪的信息

export const URL_EXPORT_PLOT_WITH_BOUND_DEVICE_IN_ONE_ROTATION = BASE_PATH + '/plotMgmt/export-plot-by-rotation' // 导出指定茬口的地块信息，含绑定的土壤仪的信息

export const URL_COLLECTIONS = BASE_PATH + '/v1/collections' // 采样记录列表接口，查询

export const URL_CUSTOMER_COLLECTED_SAMPLE = BASE_PATH + '/v1/customer-collected-sample' // 样本检测类型的采集记录，以便实验室修改采样日期

export const URL_PETIOLE_THRESHOLD_PREDICTION = '/topdressing/getPetioleIndicatorPredictList' // 获取指定地块预测的叶柄营养阈值
export const URL_PURE_ELEMENT = '/topdressing/getFertilizerSupplementDosageList' // 纯元素推荐列表

export const URL_UPDATE_COLLECTION_PLOT = BASE_PATH + '/v1/collection-plot' // 修改采集记录的地块

export const URL_EXPORT_COLLECTOIN = BASE_PATH + '/v1/collection-excel' // 导出采集记录

export const URL_EXPORT_COLLECTOIN_BY_PLOT = BASE_PATH + '/v1/collection-excel-by-plot' // 导出按地块统计的采集记录

export const URL_IMPORT_TESTING_RESULT = BASE_PATH + '/v1/testing-result-excel' // 上传检测结果

export const URL_INSPECT = BASE_PATH + '/v1/check-testing-result-excel' // 检测值校验

export const URL_IMPORT_SAMPLE_CODE_2_TEST = BASE_PATH + '/v1/testing-code-excel' // 上传待检测样本的编号

export const URL_COLLECTION = BASE_PATH + '/v1/collection' // 采样记录接口

export const URL_EXPORT_PLOT_YIELD_STATISTIC = BASE_PATH + '/statistic/v1/yield-with-indicators' // 导出符合筛选条件且测过产的所有地块的产量统计信息，含相关的其他指标值。

export const URL_EXPORT_PLOT_ROTATION_INDICATOR_VALUES = BASE_PATH + '/statistic/v1/indicator-value-excel-by-plot-rotation' // 导出指定地茬的所有采集指标值。

export const URL_EXPORT_PETIOLE_NUTRITION_4THRESHOLD = BASE_PATH + '/statistic/v1/petiole-nutrition-4threshold-excel' // 为人工判定阈值导出最近的叶柄检测值。

export const URL_EXPORT_INDICATOR_VALUES = BASE_PATH + '/statistic/v1/indicator-value-excel' // 导出采集指标值，每个指标一张表，每张表内含有所有地块。

export const URL_EXPORT_INDICATOR_VALUES_4_YEARLY_REPORT = BASE_PATH + '/statistic/v1/yearly-report-indicator-value-excel' // 为年终报告 导出采集指标值

export const URL_EXPORT_SINGLE_INDICATOR_VALUES_DAILY_STATISTIC = BASE_PATH + '/statistic/v1/single-indicator-values-daily-statistic-excel' // 导出指定地茬的指定时间范围内的指定单个指标的逐日统计值，包括每日均值、四分位值等。

export const URL_EXPORT_DAILY_COLLECTION_DURATION = BASE_PATH + '/statistic/v1/collect-duration-daily' // 导出每人每天采集的起止时间统计表。

export const URL_LIST_PLOT_ROTATION_IMAGES = BASE_PATH + '/statistic/v1/photos-by-plot-rotation' // 列出指定地茬的所有照片。

export const URL_STATISTIC_ARCHIVE_COLLECTION_IMAGES = BASE_PATH + '/statistic/v1/collection-images' // 采集的照片

export const URL_STATISTIC_ARCHIVE_COLLECTIONS = BASE_PATH + '/statistic/v1/collections' // 采集记录

export const URL_ROLE_PERMISSION_FILE_TEMPLATE = BASE_PATH + '/role-permission/template' // 上传及下载角色权限配置模板

export const URL_EVALUATOR_LIST = BASE_PATH + '/indicator/evaluatation/statistics-by-evaluator/list' // 评价人员列表

export const URL_EVALUATOR_LIST_EXCEL = BASE_PATH + '/indicator/evaluatation/statistics-by-evaluator/list/excel' // 导出评价人员统计的Excel文件

export const URL_EVALUATATION_LIST = BASE_PATH + '/indicator/evaluatation/list' // 评价详情列表

export const URL_EVALUATATION_LIST_EXCEL = BASE_PATH + '/indicator/evaluatation/list/excel' // 导出评价详情列表

export const URL_PLOT_INDICATOR_VALUE = BASE_PATH + '/statistic/v1/indicator-value' // 地茬的指标值

export const URL_PLOT_STATISTIC = BASE_PATH + '/statistic/v1/plot' // 地茬基础信息

export const URL_SERVICE_TYPE_META = BASE_PATH + '/fm/v1/service-type-meta' // 所有服务类型的定义

export const URL_PLOT_SERVICE_CONTRACT = BASE_PATH + '/fm/v1/plot-service-contract-binding' // 地块与服务合同的对应关系

export const URL_COLLECT_RULE_COMPANY = BASE_PATH + '/plotMgmt/v1/collect-rule-company' // 所有有采集规范的公司

export const URL_PLOT_COLLECT_RULE_COMPANY = BASE_PATH + '/plotMgmt/v1/plot-collect-rule-company' // 地块与采集规范所属公司的对应关系

export const URL_EXPORT_KEY_INDICATORS_EVALUATION_4_REPORT = BASE_PATH + '/statistic/v1/key-indicators-evaluation-4-report' // 导出指定地块的关键指标值及评价，用于制作种植报告。

export const URL_EXPORT_SOIL_AND_SUBSEQUENT_PETIOLE_TESTING_VALUE = BASE_PATH + '/statistic/v1/soil-petiole-after-planting-analysis' // 导出土壤检测值及后继叶柄检测值，用于分析营养相关性

export const URL_EXPORT_LAMBWESTON_TESTING_REPORT = BASE_PATH + '/v1/lambweston-testing-collection-excel' // 导出蓝维斯顿要求格式的检测结果excel

export const URL_SEASONAL_NUTRIENT_ANALYSIS = BASE_PATH + '/nutrient-analysis/seasonal-total' // 全种植季养分总量分析

export const URL_SEASONAL_NUTRIENT_RHYTHM_ANALYSIS = BASE_PATH + '/nutrient-analysis/seasonal-rhythm' // 全种植季养分节奏分析

export const URL_COCKPIT_STATISTIC_FARM_LIST = BASE_PATH + '/cockpit-statistic/farm-option' // 查询基地列表（用于农场驾驶舱的统计）

export const URL_COCKPIT_STATISTIC_FARM = BASE_PATH + '/cockpit-statistic/farm-statistic' // 基地内所有地块的指标现状统计（用于农场驾驶舱的统计）

export const URL_COCKPIT_STATISTIC_COMPANY = BASE_PATH + '/cockpit-statistic/company-statistic' // 公司内所有基地的指标现状统计（用于农场驾驶舱的统计）

export const URL_COCKPIT_NUTRIENT_DEFICIENCY_STATISTIC_FARM = BASE_PATH + '/cockpit-statistic/farm-nutrient-deficiency-statistic' // 基地内所有地块的指标现状统计（用于农场驾驶舱的统计）

export const URL_COCKPIT_NUTRIENT_DEFICIENCY_STATISTIC_COMPANY = BASE_PATH + '/cockpit-statistic/company-nutrient-deficiency-statistic' // 公司内所有基地的指标现状统计（用于农场驾驶舱的统计）

/**
 * 因为以下这些接口不是专为管理后台设计的，所以均无 BASE_PATH。
 */

export const URL_WEATHER_STATION_LIST = '/lateblight/air-condition/list' // 获取气象站及其附近的气象IoT设备汇总的气象数据列表

export const URL_WEATHER_STATION_DATA_LIST = '/lateblight/air-condition-daily/list' // 获取气象站及其附近的气象IoT设备按天汇总的气象数据列表

export const URL_LATEBLIGHT_PAGE = '/lateblight/pridiction/list' // 获取所有基于气象站的晚疫病中心病发病株预测结果

export const URL_LATEBLIGHT_PREDICTION_STATE = '/lateblight/pridiction' // 变更晚疫病预测状态。

export const URL_LATEBLIGHT_WEATHER_INDICATORS = '/lateblight/weather-station-air-condition-daily/list' // 获取气象站按天汇总的气象数据列表

export const URL_GET_FIELD_PATROL_RESULTS = '/farming/plot-inspect-page' // 采样记录接口

export const URL_GET_FIELD_PATROL_PLOT_LIST = '/farming/inspected-plot-summary' // 巡田记录 获取地块的数据源

export const URL_FIELD_PATROL_DETAILS = '/farming/plot-inspect' // 根据ID查询巡田记录。

export const URL_GET_ALL_COMPANY_LIST = '/organization/company-list/by-name' // 搜索公司接口

export const URL_OFFICIAL_COMPANY = '/organization/official-company' // 查询有权限查看的公司列表

export const URL_GET_ALL_PLOTMGMT_LIST = '/organization/plot_mgmt-list/by-name' // 搜索指定公司下的基地接口

export const URL_FARM = '/organization/farm' // 有权限查看的的基地接口

export const URL_GET_ALL_PLOT_LIST = '/organization/plot-list/by-name' // 搜索指定基地下的地块接口

export const URL_GET_COMPANY_LEADER_INFO = '/organization/company-leader-by-plot_mgmt_id' // 获取公司负责人信息接口

export const URL_POST_FARMING_PLOT_INSPECT = '/farming/plot-inspect' // 添加巡察地块记录

export const URL_GET_REMOTE_SENSING_PLOT_INSPECT = '/farming/plot-remote-sensing-inspect-page' // 分页获取所有地块遥感式巡察记录

export const URL_POST_REMOTE_SENSING_PLOT_INSPECT = '/farming/plot-remote-sensing-inspect' // 添加遥感式巡察地块记录

export const URL_GET_VERSION_INFO = '/api/version/list' // 获取所有版本信息列表

export const URL_POST_VERSION_INFO = '/api/version' // 新建版本

export const URL_ATTACHMENT = '/api/attachment' // 附件，包括图片、文件等

export const URL_EVALUATION_PERMISSION = '/indicator/evaluatation/permission' // 授权用户采集样本的评价权限

export const URL_ALL_ROLES = '/authorization/roles' // 获取系统所有角色

export const URL_USER_AUTHORIZATION_DETAILS = '/authorization/user-authorization-details' // 获取用户的所有授权

export const URL_STAFF_ROLE_LIST = '/authorization/user-authorizations' // 获取员工角色配置表

export const URL_SAMPLE_TESTING_LIST = '/indicator/collection/sample-testing/list' // 获取实验室检测统计

export const URL_SAMPLE_TESTING_LIST_EXCEL = '/indicator/collection/sample-testing/list/excel' // 导出实验室检测统计Excel文件

export const URL_SAMPLE_UNTESTED_LIST_EXCEL = '/indicator/collection/sample-testing/untested-list/excel' // 导出未检测样本的Excel文件

export const URL_USER_BEHAVIOR_REPORT = '/information/user-behavior/user-behavior-reports' // 导出用户埋点表

export const URL_QUALITY_INDICATOR_EXPORT = BASE_PATH + '/quality-indicator-excel' // 品质指标导出

export const URL_INDICATOR_UPDATE_VALUE = '/indicator/indicator-value' // 更新指标值信息

export const URL_INDICATOR_UPDATE_UNDERLYING_VALUE = '/indicator/indicator-underlying-value' // 更新需要求平均值的指标值信息

export const URL_QUALITY_PHOTO_UPLOAD = '/image-attachment/quality-indicator' // 获取品质照片列表和编辑品质照片指标以及上传或删除品质照片

export const URL_INDICATOR_META = '/indicator/all-indicators' // 指标项的元信息

export const URL_GET_PLANTING_REPORT = '/planting-report' // 获取种植报告数据

export const URL_BOSS_OF_COMPANY = '/personnel/v1/boss-of-company' // 根据公司id查询老板信息

export const URL_USER = '/personnel/v2/user' // 查询人员信息

export const URL_REALTIME_WEATHER = '/weather/fixed-location/real/daily' // 获取逐日的天气实况数据

export const URL_PREDICT_WEATHER = '/weather/fixed-location/predict/daily' // 获取逐日的天气预报数据

export const URL_FIXED_WEATHER_LOCATION = '/weather-station/typeof' // 获取地面固定的站点信息

export const URL_AGRONOMIST_FERTILIZATION = '/topdressing/topdressing-list' // 初农配肥列表

export const URL_FERTILIZATION_RECORD = '/topdressing/topdressing-record-list' // 配肥记录

export const URL_FERTILIZATION_DETAILS = '/topdressing/fertilization-basis' // 配肥详情

export const URL_SUBMIT_DATA = '/topdressing' // 提交配肥数据

export const URL_CALCULATE_DATA = '/topdressing/pure-element-supplementary-dosage' // 计算

export const URL_GET_PARCEL_LIST = '/plot-offline-service/live-plot-summary' // 上传线下资料 获取地块列表

export const URL_SUBMIT_ANNEX = '/plot-offline-service/attachment' // 提交地块线下服务资料

export const URL_CROPS_ROTATION_META = '/plot/crops-rotation' // 所有茬口的定义

export const URL_AVAILABLE_CROPS_ROTATION_META = '/plot/available-crops-rotation' // 所有有权限查看的地块对应的茬口

export const URL_AGRICULTURAL_MATERIALS_COLLECTOR = '/farming/v1/agricultural-materials-collector' // 投入品采集记录的所有采集人员的ID

export const URL_AGRICULTURAL_MATERIALS_PLOT = '/farming/v1/agricultural-materials-plot' // 投入品采集记录涉及的地茬

export const URL_AGRICULTURAL_MATERIALS_COLLECT = '/farming/v2/agricultural-materials-collect' // 投入品采集记录

export const URL_CROPS_GROWTH_STAGE_META = '/crop/v1/growth-stage-meta' // 所有生育期的定义

export const URL_PLOT_GROWTH_STAGE = '/plot/v1/plot-growth-stage' // 地茬的生育期

export const URL_PLOT_WITH_FARM_FARMER = '/plot/v1/plot-with-farm-farmer' // 地茬与基地和薯农的信息

export const URL_GET_SOIL_MOISTURE = '/indicator/watering-suggestion' // 获取土壤仪湿度表现

export const URL_GET_SOIL_MOISTURE_MULTI_PLOTS = '/indicator/watering-suggestion-multi-plots' // 获取土壤仪湿度表现,支持多个地块

export const URL_GET_SOIL_TEMPERATURE = '/indicator/soil-temperature-daily' // 获取土壤仪温度表现

export const URL_GET_SOIL_TEMPERATURE_MULTI_PLOTS = '/indicator/soil-temperature-daily-multi-plots' // 获取土壤仪温度表现,支持多个地块

export const URL_GET_MASSIF_GROWTH_ANALYSIS = '/farming/rotational-plot-basic-and-growth' // 获取地块的长势及养分指标分析

export const URL_GET_GROWTH_ANALYSIS = '/farming/plot-growth-factor' // 获取长势分析

export const URL_USER_PASSWORD = '/login/password' // 用户密码

export const URL_CANOPY_DIE_BACK = '/farming/canopy-die-back-timestamp' // 获取当前地块是否存在回秧时间

export const URL_PLOT_SEEDING_PREDICT = BASE_PATH + '/farming/suitable-sowing-date' // 播种时间预测

export const URL_PRE_SOIL_SAMPLE_BY_TESTING_CODE = '/indicator-collection/v1/pre-soil-sample' // 上一次土壤样本

// 派生指标
export const URL_DERIVED_INDICATOR_CANOPY_COVERAGE = '/derived-indicator-value/canopy-coverage-percentage-value' // 冠层覆盖率
export const URL_DERIVED_INDICATOR_DAILY_AVG_OVERALL = '/derived-indicator-value/daily-derived-overall-avg-indicator-value' // 基于单日的全田平均指标值
export const URL_DERIVED_INDICATOR_COLLECTLY = '/derived-indicator-value/collectly-derived-indicator-value' // 基于单次采集的派生指标值
export const URL_DERIVED_INDICATOR_VALUE = '/derived-indicator-value/value' // 派生指标值
export const URL_DERIVABLE_INDICATOR_META = '/derived-indicator-value/derivable-indicator' // 可派生出的指标的定义
export const URL_COLLECTLY_DERIVABLE_INDICATOR_META = '/derived-indicator-value/collectly-derivable-indicator' // 可由单次采集派生指标值
export const URL_DAILY_DERIVABLE_INDICATOR_META = '/derived-indicator-value/daily-derivable-indicator' // 可由单日采集派生出的指标的定义

// 考勤打卡模块
export const URL_DAILY_SUMMARY = '/check-in/daily-page' // 按日汇总
export const URL_DAILY_SUMMARY_EXPORT = '/check-in/daily-page-export' // 按日汇总导出
export const URL_PUNCH_IN_DETAILS = '/check-in/list-page' // 打卡明细
export const URL_PUNCH_IN_DETAILS_EXPORT = '/check-in/list-page-export' // 打卡明细导出

// 知识库模块
export const URL_GET_TYPE_LIST = '/knowledge-item/getKnowledgeTypeList' // 获取知识库类型
export const URL_GET_KNOWLEDGE_LIST = '/knowledge-item/list' // 获取知识库列表
export const URL_GET_DETAILS = '/knowledge-item/' // 知识库 查询详情和删除接口

// 查询承德晚疫病预测
export const URL_FORECAST_RESULT = '/lateblight/pc_cd_station_data' // 站点预测结果
export const URL_FORECAST_DETAILS = '/lateblight/pc_risk_list_data' // 站点详情
export const URL_FILE_UPLOAD = '/lateblight/upload' // 站点详情

// 评分功能
export const URL_SCORE_LIST = '/plotscore/getTotalScoreList' // 评分列表
export const URL_URL_SCORE_DETAILS = 'plotscore/getAllSocreItemsByPlotId' // 评分详情

// 指标值评价
export const URL_PETIOLE_INDICATOR_EVALUATION = '/topdressing/topdressing-summary-history' // 叶柄检测值评价列表
export const URL_PETIOLE_INDICATOR_EVALUATION_MULTI_PLOTS = '/topdressing/topdressing-summary-history-multi-plots' // 叶柄检测值评价列表
export const URL_GROWTH_INDICATOR_EVALUATION = '/indicator/evaluatation/v1/indicator-values' // 长势指标值评价列表

// 统计界面
export const URL_STATISTICAL_LIST = 'company_summary/getOrgList' // 统计地图基地列表和 右侧基地列表数据
export const URL_CROP_LOGICAL_PLOT_BOUNDRY_WHOLE = '/plot/getPlatInfoWithPlotID' // 获取地块对应基地下的全部播种圈地更详细的信息
export const URL_GROWTH_RATING = '/company_summary/getOrgGrowthList' // 长势评分
export const URL_GROWTH_RATING_DETAILS = '/company_summary/getOrgGrothItemEvaluationList' // 长势评分 详情

export const URL_NUTRIENT_DEFICIENCY = '/company_summary/getOrgPoolElementList' // 缺素情况
export const URL_NUTRIENT_DEFICIENCY_DETAILS = '/company_summary/getOrgPoolElementItemList' // 缺素情况详情

export const URL_IRRIGATE = '/company_summary/getOrgSoilEvaluationList' // 灌溉情况
export const URL_IRRIGATE_DETAILS = '/company_summary/getOrgSoilItemList' // 灌溉情况

// 地块对比
export const URL_PLOT_COMPARISION_SCORE = '/company_summary/contrast-info-multi-plots' // 用于地块对比的分数

// 基地看板
export const URL_PLOT_OF_FARM = '/company_summary/getOneOrgPlotsSummaryDTOListByOrgId' // 特定基地下的所有地块

export const URL_CHINA_COUNTY = '/weather_county_daily/getCountyList' // 国家县级单位接口
export const URL_CROP_SPECIES_META = '/crop/v1/species-meta' // 作物定义
export const URL_CROP_VARIETY_META = '/crop/v1/cultivar-meta' // 作物品种定义
export const URL_COUNTY_GDD = '/weather_county_daily/getWeatherDataList' // 县级单位积温
export const URL_COUNTY_DAILY_METEOROLOGY = '/weather_county_daily/daily-meteorology' // 县级单位逐日气象信息
export const URL_AUTH_MIMIC_USER = '/authorization/mimic-user' // 模拟用户，复制权限

export const URL_FERT_RECOMMEND_SINGLE_TIME = '/fertilization-recommendation/single-time' // 单次用肥建议
export const URL_FERT_ACTUAL = '/fertilization-actual/fertilization' // 实际施肥记录
export const URL_FERT_ACTUAL_DAILY = '/fertilization-actual/fertilization-daily' // 实际逐日施肥记录

export const URL_FERTILIZER_MANAGEMENT_BASIC_FERT = '/fertilizer/basic-fert' // 基础肥料相关的接口
export const URL_FERTILIZER_MANAGEMENT_INGREDIENT = '/fertilizer/ingredient' // 肥料成分相关的接口
export const URL_FERTILIZER_MANAGEMENT_INGREDIENT_OPTIONS = '/fertilizer/ingredient-option' // 成分的可选项
export const URL_FERTILIZER_MANAGEMENT_INGREDIENT_FORM_OPTIONS = '/fertilizer/ingredient-form' // 成分形态的可选项
export const URL_FERTILIZER_MANAGEMENT_INGREDIENT_CONTENT = '/fertilizer/ingredient-content' // 肥料成分含量相关的接口

export const URL_SATELLITE_IMAGE = '/satellite-img/img' // 卫星图像相关的接口
export const URL_COLLECT_DENSITY_CENTER = '/indicator-collect/density-center' // 指定地块指定时间段内的采集位置的密度中心
export const URL_EXPORT_EMERGENCE_DATE_RECENT_NDVI = '/satellite-img/v1/plot-emergence-ndvi-excel' // 导出指定茬口的播种日期及其前、后各一次的卫星指数。



// WEBPACK FOOTER //
// ./src/constants/url.js